<template>
  <svg
    id="Calque_1"
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 239.89 97.85"
    class="analyze"
    @click="switchM()"
  >
    <defs>
      <linearGradient
        id="gradient_sans_nom_53"
        y1="48.93"
        x2="239.89"
        y2="48.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#d51f27"></stop>
        <stop offset="0.93" stop-color="#f04e4c"></stop>
      </linearGradient>
    </defs>
    <title>analyze</title>
    <polygon
      class="cls-1"
      points="28.23 97.85 0 48.91 28.27 0 211.62 0 239.89 48.91 211.66 97.85 28.23 97.85"
    ></polygon>
    <text class="cls-2" transform="translate(34.75 63.14)">{{this.title}}</text>
  </svg>
</template>
<script>
export default {
  props: ["time", "titlebtn", "valid"],
  data() {
    return {
      title: this.titlebtn
    };
  },
  computed: {
    getImages: function() {
      return this.$store.getters["image/getPreviews"];
    }
  },
  methods: {
    switchM() {
      if (this.titlebtn == "CREATE") {
        let images = this.$store.getters["image/getPreviews"];
        if (images.length == 0) {
          this.$store.commit('dialogModal/toggleNotif', [this.$t('titles.noImage'), this.$t('texts.addAndRetry')]);
          return;
        }
        this.$router.push("/newproject");
      } else if (this.titlebtn == "ANALYZE") {
        if (this.valid) {
          this.saveAndGo(this.time);
        }
        else {}
      }
    },
    async nextPageProject() {
      await this.$store.dispatch("image/getImages");
      this.$router.replace("/projects/" + this.project.uuid);
    },
    async uploadAnalyze() {
      this.project = await this.$store.getters["project/getProject"];
      // 
      
      this.getImages.forEach(img => {
        let formData = new FormData();
        formData.append("file_url", img);
        formData.append("name", img.name);
        formData.append("media_type", "IMG");
        formData.append("project", this.project.uuid);
        formData.append("width", img.width);
        formData.append("height", img.height);
        // send request upload image
        this.$store.dispatch("image/postImg", formData);
      });
    },
    async saveAndGo() {
      setTimeout(async () => {
        
        await this.uploadAnalyze();
        this.nextPageProject();
        this.$store.dispatch("image/initPreviews");
      }, this.time);
      
    }
  }
};
</script>

<style scoped>
.cls-1 {
  fill: url(#gradient_sans_nom_53);
}
.cls-2 {
  font-size: 40.17px;
  fill: #262624;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
}
.analyze {
  position: absolute;
  /* right: 0px !important;  */
  width: 109px;
}
</style>
